<ion-header mode="ios">
  <ion-toolbar>
    <ion-title>{{ 'pages.fund-cash.purchase.title' | translate }}</ion-title>
  </ion-toolbar>

  <ui-current-cdc [project]="project" [showRole]="false"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <div class="flex flex-column min-height-100">
    <front-end-fund-cash-purchase-card
      [cashFund]="cashFund"
      (openSplitModalClick)="openSplitModal()"
      [project]="project"
      [showSplit]="true"
      [splitRows]="splitRows"
      [amount]="remainingAmount"
    ></front-end-fund-cash-purchase-card>

    <form id="fund-cash-send-form" [formGroup]="form" (ngSubmit)="save()">
      <ui-form-field
        *ngIf="showBudgetItemControl"
        [control]="form.controls.budgetItem"
        icon="chevron-forward"
        iconSlot="end"
        iconClasses="icon-end fs-16 pt-32"
        class="fs-16"
        lines="full"
        label="pages.fund-cash.purchase.form.budgetItem"
      >
        <ui-budget-item-select
          [formControl]="form.controls.budgetItem"
          [project]="project"
          [projectTasks]="budgetProjectTasks"
          [allowedSubtasks]="allowedSubtasks"
          [articleFormControl]="form.controls.article"
        ></ui-budget-item-select>
      </ui-form-field>

      <div class="cashfund-purchase-document">
        <div class="purchase-document-header">
          <span class="font-medium ion-text-uppercase">
            {{ 'pages.fund-cash.purchase.confirm.document.label' | translate }}
          </span>

          <ion-segment
            class="purchase-document-segment"
            mode="md"
            [value]="purchaseDocumentType"
            (ionChange)="onPurchaseDocumentTypeChange($event)"
          >
            <ion-segment-button [value]="PurchaseDocumentType.RECEIPT">
              <ion-label>{{ 'pages.fund-cash.purchase.confirm.document.receipt' | translate }}</ion-label>
            </ion-segment-button>
            <ion-segment-button [value]="PurchaseDocumentType.INVOICE">
              <ion-label>{{ 'pages.fund-cash.purchase.confirm.document.invoice' | translate }}</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div>

        <ui-file-input
          [value]="purchaseDocumentAttachment"
          (attachment)="onAttachPurchaseDocument($event)"
          label="pages.fund-cash.purchase.confirm.document.attach"
        ></ui-file-input>
      </div>
    </form>

    <ui-form-field [control]="form.controls.notes" label="pages.fund-cash.purchase.confirm.notes" class="fs-16" data-cy="Notes">
      <ion-textarea [formControl]="form.controls.notes" [autoGrow]="true" [rows]="1"></ion-textarea>
    </ui-form-field>

    <div class="font-medium block ion-text-uppercase cashfund-other-attachments-title">
      {{ 'pages.fund-cash.purchase.confirm.otherAttachments.label' | translate }}
    </div>

    <div class="cashfund-other-attachments">
      <div class="file-col" *ngIf="shouldShowOtherAttachment(0)">
        <ui-file-input
          [value]="getOtherAttachment(0)"
          (attachment)="onAttachOtherAttachment(0, $event)"
          label="pages.fund-cash.purchase.confirm.otherAttachments.otherAttachment"
        ></ui-file-input>
      </div>
      <div class="file-col" *ngIf="shouldShowOtherAttachment(1)">
        <ui-file-input
          [value]="getOtherAttachment(1)"
          (attachment)="onAttachOtherAttachment(1, $event)"
          label="pages.fund-cash.purchase.confirm.otherAttachments.otherAttachment"
        ></ui-file-input>
      </div>
      <div class="file-col" *ngIf="shouldShowOtherAttachment(2)">
        <ui-file-input
          [value]="getOtherAttachment(2)"
          (attachment)="onAttachOtherAttachment(2, $event)"
          label="pages.fund-cash.purchase.confirm.otherAttachments.otherAttachment"
        ></ui-file-input>
      </div>
      <div class="file-col" *ngIf="shouldShowOtherAttachment(3)">
        <ui-file-input
          [value]="getOtherAttachment(3)"
          (attachment)="onAttachOtherAttachment(3, $event)"
          label="pages.fund-cash.purchase.confirm.otherAttachments.otherAttachment"
        ></ui-file-input>
      </div>
    </div>

    <ui-bottom-actions>
      <div class="flex flex-column gap-4">
        <ion-button type="submit" form="fund-cash-send-form" color="primary" data-cy="Confirm cash fund purchase" [disabled]="!form.valid">
          {{ 'pages.fund-cash.purchase.confirm.submit' | translate }}
        </ion-button>
      </div>
      <div class="divider flex ion-align-items-center ion-justify-content-center">
        <ion-button fill="clear" type="submit" form="fund-cash-send-form" (click)="setIsDraft()"
          >{{ 'pages.fund-cash.purchase.saveDraft.link' | translate }}
        </ion-button>
      </div>
    </ui-bottom-actions>
  </div>
</ion-content>
